import React from 'react';
import PropTypes from 'prop-types';
import { CheckIcon, CircleIcon } from '../../model/icons';

export const MIN_PASSWORD_LENGTH = 8;

export const isValidPassword = (password) => password.length >= MIN_PASSWORD_LENGTH && /\d/.test(password);

const RULES = [
    { test: (p) => p.length >= MIN_PASSWORD_LENGTH, label: `Минимум ${MIN_PASSWORD_LENGTH} символов` },
    { test: (p) => /\d/.test(p), label: 'Содержит цифру' }
];

// Живой чек-лист требований к паролю (под полем ввода) — появляется, когда начат ввод.
export default function PasswordRules({ password }) {
    if (!password) return null;
    return (
        <div className="pw-rules">
            {RULES.map((rule, i) => {
                const ok = rule.test(password);
                return (
                    <div className={`pw-rule${ok ? ' ok' : ''}`} key={i}>
                        {ok ? <CheckIcon /> : <CircleIcon />}
                        {rule.label}
                    </div>
                );
            })}
        </div>
    );
}

PasswordRules.propTypes = {
    password: PropTypes.string.isRequired
};
